<template>
  <form autocomplete="off">
    <div class="columns">
      <div class="column field is-9">
        <label class="label">Post Title</label>
        <div class="control">
          <validation-provider v-slot="{ errors, failed }" rules="required">
            <input
              v-model="model.title"
              autocomplete="off"
              class="input"
              type="text"
              :disabled="!editing"
              :class="{ 'is-danger': failed }"
            />
            <span class="help is-danger">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column field is-12">
        <label class="label">Post to user, project, or organization?</label>
        <div class="control">
          <validation-provider v-slot="{ errors, failed }" rules="required">
            <div class="level">
              <div class="level-item">
                <app-radio
                  v-model="model.type"
                  data="user"
                  name="user"
                  value="user"
                  @input="onChangeType"
                >
                  User
                </app-radio>
              </div>
              <div class="level-item">
                <app-radio
                  v-model="model.type"
                  data="project"
                  name="project"
                  value="project"
                  @input="onChangeType"
                >
                  Project
                </app-radio>
              </div>
              <div class="level-item">
                <app-radio
                  v-model="model.type"
                  data="organization"
                  name="organization"
                  value="organization"
                  @input="onChangeType"
                >
                  Organization
                </app-radio>
              </div>
              <div class="level-item">
                <div class="select">
                  <select>
                    <option
                      v-for="(item, index) in postTo"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <span class="help is-danger">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column field is-12">
        <label class="label">Post Content</label>
        <div class="control">
          <validation-provider v-slot="{ errors, failed }" rules="required">
            <textarea
              v-model="model.description"
              autocomplete="off"
              class="input"
              :disabled="!editing"
              :class="{ 'is-danger': failed }"
            ></textarea>
            <span class="help is-danger">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column field is-9">
        <label class="label">Upload a new file</label>
        <div class="control">
          <validation-provider
            v-slot="{ errors, failed }"
            ref="fileValidator"
            rules="required"
          >
            <div class="file has-name is-fullwidth is-right">
              <label class="file-label" :class="{ 'is-danger': failed }">
                <input
                  ref="fileToUpload"
                  class="file-input"
                  type="file"
                  @change="handleFileChange"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="icon icon-upload"></i>
                  </span>
                  <span class="file-label">
                    Upload
                  </span>
                </span>
                <span class="file-name">
                  {{
                    (fileToUpload && fileToUpload.name) || 'No file selected'
                  }}
                </span>
              </label>
            </div>
            <span class="help is-danger">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column field is-9">
        <label class="label">Add Link</label>
        <div class="control">
          <validation-provider v-slot="{ errors, failed }" rules="required">
            <input
              v-model="model.password"
              autocomplete="off"
              class="input"
              type="url"
              :class="{ 'is-danger': failed }"
            />
            <span class="help is-danger">{{ errors[0] }}</span>
          </validation-provider>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import AppRadio from '@/components/AppRadio.vue';
import Form from './Form.js';
import { ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import '@/validation.js';

export default {
  name: 'FeedForm',
  components: {
    ValidationProvider,
    AppRadio
  },
  extends: Form,
  data() {
    return {
      postTo: [],
      fileToUpload: null /*,
      file: {},
      selectedFileId: -1,
      isUploading: -1,*/
    };
  },
  methods: {
    onChangeType(item) {
      //console.log(item);
      /*if (item[0] == 'user') {
        this.postTo = this.$store.getters['users/list'];
      } else if (item[0] == 'project') {
        this.postTo = this.$store.getters['projects/list'];
      } else if (item[0] == 'organization') {
        this.postTo = this.$store.getters['projects/list'];
      }*/
    },
    async handleFileChange(e) {
      /*const { valid } = await this.$refs.fileValidator.validate(e);
      if (valid) {
        this.fileToUpload = this.$refs.fileToUpload.files[0];
      }*/
    },
    onUploadProgress(progressEvent) {
      const percentCompleted = progressEvent.loaded / progressEvent.total;
      this.isUploading = 1 - percentCompleted;
      //console.log(percentCompleted);
    },
    handleFileUpload() {
      /*
      this.$refs.formfile.validate().then(success => {
        if (!success) {
          this.showErrorMessage('Please check the errors');
          return;
        } else {
          if (this.selectedFileId != -1) {
            this.updateFile();
          } else {
            this.isUploading = 0;
            const formData = new FormData();
            formData.append('fileContent', this.fileToUpload);
            this.axiosRequest('post', 'Files/Content', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress: this.onUploadProgress
            })
              .then(response => {
                return axios.all([
                  this.axiosRequest(
                    'post',
                    `Projects/${this.project.projectID}/Files/${response.data.fileID}`
                  ),
                  this.axiosRequest('put', `Files/${response.data.fileID}`, {
                    fileID: response.data.fileID,
                    organizationID: this.$store.getters.userOrganization,
                    name: this.file.name,
                    description: this.file.description,
                    organizationTags: this.file.organizationTags || [],
                    systemTags: this.file.systemTags || []
                  })
                ]);
              })
              .then(
                axios.spread((response, file) => {
                  this.projectFiles.push(file.data);
                  this.fileToUpload = null;
                  this.$refs.fileToUpload.value = '';
                  this.uploadFileDialog = false;
                  this.isUploading = -1;
                  this.showSuccessMessage('File created with success.');
                })
              )
              .catch(error => {
                this.showErrorMessage(error);
              });
          }
        }
      });
      */
    }
  }
};
</script>

<style lang="scss" scoped>
textarea {
  height: 90px;
}
</style>
